import { FC, useRef, useState } from 'react';
import { Button, Card, Col, Form, Modal, Result, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { PaymentFields } from 'components/shared';
import { PaymentFieldsRef } from 'components/shared/PaymentFields';

const { Title } = Typography;

const PaymentInfo: FC = () => {
  const { t } = useTranslation();
  const ref = useRef<PaymentFieldsRef>(null);
  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <Card>
      <Row justify="space-between" align="middle">
        <Col>
          <Title level={3}>{t('profile.bank_account_details')}</Title>
        </Col>
        <Col>
          <Form.Item>
            <Button type="primary" onClick={() => ref.current?.submit()}>
              {t('common.save')}
            </Button>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <PaymentFields ref={ref} onCompleted={() => setShowSuccess(true)} />
        </Col>
      </Row>
      <Modal
        style={{ borderRadius: 16 }}
        footer={null}
        open={showSuccess}
        onCancel={() => setShowSuccess(false)}
      >
        <Result
          status="success"
          title={t('common.success')}
          subTitle={t('profile.payment_info_saved')}
          extra={[
            <Button
              key="ok"
              type="primary"
              onClick={() => {
                setShowSuccess(false);
                ref.current?.setEditSignature(false);
              }}
            >
              OK
            </Button>
          ]}
          style={{ padding: 0 }}
        />
      </Modal>
    </Card>
  );
};

export default PaymentInfo;
